// core
import { version } from "../../core/config";
import Dashboard from "../../assets/svg/dashboard-icon.svg";
import City from "../../assets/svg/city-icon.svg";
import Credit from "../../assets/svg/credit-icon.svg";
import Car from "../../assets/svg/car-icon.svg";
import Driver from "../../assets/svg/driver-icon.svg";
import Product from "../../assets/svg/product-icon.svg";
import Repair from "../../assets/svg/repair-icon.svg";
import Notifications from "../../assets/svg/message-icon.svg";
// components
import { SidebarItem } from "./SidebarItem";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const Sidebar = () => {
  const location = useLocation();
  const store = useSelector((state) => state.Store);

  const items = [
    {
      key: "Dashboard",
      name: "Dashboard",
      link: "/",
      icon: Dashboard,
    },
    {
      key: "CitiesAndUsers",
      name: "Cities and Employees",
      link: "/cities-and-users/",
      icon: City,
      isDeactive: store?.user?.user_type !== "company_owner",
    },
    {
      key: "CreditManagement",
      name: "Credit Management",
      link: "/credit/",
      icon: Credit,
      isDeactive: store?.user?.user_type !== "company_owner",
    },
    {
      key: "cars",
      name: "Cars Management",
      link: "/cars/",
      icon: Car,
    },
    {
      key: "drivers",
      name: "Drivers Management",
      link: "/drivers/",
      icon: Driver,
    },
    {
      key: "BuyProductReport",
      name: "Purchases Report",
      link: "/buy-product-report/",
      icon: Product,
    },
    {
      key: "CarsServiceReport",
      name: "Cars Service Report",
      link: "/cars-service-report/",
      icon: Repair,
    },
    {
      key: "Notifications",
      name: "Notifications",
      link: "/notifications/",
      icon: Notifications,
    },
    // {
    //   key: "MessagesReport",
    //   name: "گزارش پیام",
    //   link: "/messages-report/",
    //   icon: Message,
    // },
  ];

  return (
    <div className="sidebar">
      <div className={"content show-sidebar"}>
        {items.map((item) => (
          <SidebarItem isActive={location.pathname === item.link} {...item} />
        ))}
        <div className="version">
          <small>نسخه {version}</small>
        </div>
      </div>
    </div>
  );
};
